import React from 'react';

const DesktopBg = (props) => {
  return (
    <div className="svg client-dash__desktop-bg">
      <svg
        width="650"
        height="650"
        viewBox="0 0 93 93"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M77.057 58.1473H71.8009C72.9797 66.2975 70.1785 72.482 62.3095 75.4305C56.3849 77.6538 50.9101 76.1017 46.371 71.5292C40.9933 76.5272 34.8986 78.0313 28.251 74.4896C21.7917 71.0438 19.6954 65.3266 20.8256 58.1952H15.5391V33.9544H20.8195C19.6103 26.1398 22.2049 20.135 29.4967 16.9708C35.6825 14.286 41.4369 15.8202 46.2859 20.5006C51.5785 15.6164 57.4787 14.292 64.0777 17.4023C69.5648 19.9852 73.2532 26.2057 71.734 33.9004H77.057V58.1533V58.1473ZM26.7623 42.9555C26.027 37.6399 24.9332 35.902 21.8464 35.0451V57.0925C25.5652 55.7082 26.7926 52.9036 26.7076 49.2719C28.6885 57.7398 33.8899 62.9954 42.5063 65.1648C37.5662 66.1536 35.3544 67.7178 35.2875 70.1089H57.5881C56.2391 66.693 53.687 65.3386 50.2477 65.2128C58.5846 63.1153 63.6038 57.8716 65.8885 49.4997C66.3078 54.0542 67.9788 56.4333 70.8469 56.9607V35.0391C67.8269 35.7342 66.3017 37.9935 65.8946 42.6319C63.6828 34.236 58.5907 29.0223 50.3571 26.8649C54.3797 26.4814 56.8346 24.7854 57.3997 21.9328H35.0384C35.567 23.5928 36.4542 24.8633 37.8943 25.5585C39.2251 26.1997 40.7016 26.5473 42.0688 27.0087C33.8413 29.1661 28.6399 34.3859 26.7683 42.9615L26.7623 42.9555Z"
          fill="#C0D7E9"
        />
        <path
          d="M15.1953 76.5699C15.5295 76.498 15.8698 76.3601 16.204 76.3601C20.8039 76.3482 25.3977 76.3482 29.9975 76.3541C30.2406 76.3541 30.4776 76.3901 30.83 76.4201V83.7493H61.6437V76.456H77.1508C75.2428 78.5175 73.7115 80.4712 71.8825 82.0952C62.9562 90.0237 52.4257 93.2239 40.5706 91.5818C30.8543 90.2394 22.803 85.6909 16.599 78.104C16.1615 77.5707 15.6693 77.0733 15.2014 76.5639L15.1953 76.5699Z"
          fill="#C0D7E9"
        />
        <path
          d="M61.7661 8.28084H30.9281V15.61H15.3359C22.8647 5.37434 33.225 0.184583 45.548 0.00479956C58.26 -0.180977 68.9302 5.02676 76.8843 15.5621H61.7661V8.28084Z"
          fill="#C0D7E9"
        />
        <path
          d="M15.1972 76.5616C14.6078 75.5368 13.9272 74.554 13.4533 73.4813C12.2623 70.8085 11.0895 68.1298 10.0808 65.391C9.74662 64.4921 9.44887 64.1026 8.44626 64.1266C5.6754 64.1865 2.89847 64.1505 0 64.1505V27.9181C2.41843 27.9181 4.87331 27.9181 7.32819 27.9181C9.69801 27.9181 9.60686 27.8882 10.2813 25.7068C11.3569 22.231 12.8942 18.9589 15.3248 15.7528V30.8546H7.8933V61.1002H15.4524C15.4524 63.1857 15.4524 65.1154 15.4524 67.0391C15.4524 69.6819 15.4646 72.3187 15.4403 74.9615C15.4403 75.4949 15.2823 76.0342 15.1972 76.5676V76.5616Z"
          fill="#C0D7E9"
        />
        <path
          d="M91.9984 64.1582H82.6954C81.9358 66.2617 81.3342 68.2633 80.4896 70.163C79.645 72.0627 78.5634 73.8546 77.2873 75.6344V61.1439H84.7553V30.9342H77.2266V16.1919C79.9245 19.9015 81.474 23.7189 82.5435 27.8839H91.9984V64.1582Z"
          fill="#C0D7E9"
        />
      </svg>
    </div>
  );
};

export default DesktopBg;



// WEBPACK FOOTER //
// ./src/svg/DesktopBg.js